/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTemplateStar1Fragment, TemplateStar1Fragment, FullTemplateStar1Fragment} from '@amblique/contentful/app/contentful/fragments/template-star1';

/**
 * Get a single TemplateStar1 by ID (base - scalars only)
 */
export const getBaseTemplateStar1ById = gql`
  ${BaseTemplateStar1Fragment}

  query GetBaseTemplateStar1ById($id: String!, $locale: String!, $preview: Boolean) {
    templateStar1(id: $id, locale: $locale, preview: $preview) {
      ...BaseTemplateStar1Fragment
    }
  }
`;

/**
 * Get a single TemplateStar1 by ID (standard - 1 level deep)
 */
export const getTemplateStar1ById = gql`
  ${TemplateStar1Fragment}

  query GetTemplateStar1ById($id: String!, $locale: String!, $preview: Boolean) {
    templateStar1(id: $id, locale: $locale, preview: $preview) {
      ...TemplateStar1Fragment
    }
  }
`;

/**
 * Get a single TemplateStar1 by ID (full - 2 levels deep)
 */
export const getFullTemplateStar1ById = gql`
  ${FullTemplateStar1Fragment}

  query GetFullTemplateStar1ById($id: String!, $locale: String!, $preview: Boolean) {
    templateStar1(id: $id, locale: $locale, preview: $preview) {
      ...FullTemplateStar1Fragment
    }
  }
`;

/**
 * Get all TemplateStar1 entries with pagination (base - scalars only)
 */
export const getBaseTemplateStar1s = gql`
  ${BaseTemplateStar1Fragment}

  query GetBaseTemplateStar1s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TemplateStar1Order]
    $where: TemplateStar1Filter
    $preview: Boolean
  ) {
    templateStar1Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseTemplateStar1Fragment
      }
    }
  }
`;

/**
 * Get all TemplateStar1 entries with pagination (standard - 1 level deep)
 */
export const getTemplateStar1s = gql`
  ${TemplateStar1Fragment}

  query GetTemplateStar1s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TemplateStar1Order]
    $where: TemplateStar1Filter
    $preview: Boolean
  ) {
    templateStar1Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...TemplateStar1Fragment
      }
    }
  }
`;

/**
 * Get all TemplateStar1 entries with pagination (full - 2 levels deep)
 */
export const getFullTemplateStar1s = gql`
  ${FullTemplateStar1Fragment}

  query GetFullTemplateStar1s(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TemplateStar1Order]
    $where: TemplateStar1Filter
    $preview: Boolean
  ) {
    templateStar1Collection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullTemplateStar1Fragment
      }
    }
  }
`;
